import { forwardRef } from 'react'
import styled from 'styled-components/macro'

export const Measure = forwardRef( ( { children}, ref ) => {

  return (
    <>
      <Box ref={ref}>
        { children }
      </Box>
    </>
  )
})

const Box = styled.div`
  // width: 100%;
  height: 100%;
  position: relative;
  transition: right 0.3s ease;
    // margin: 0 auto; 
  /* border:10px solid blue; */
`